<div class="d-flex mb-3 justify-content-between flex-column mt-5 text-center">
  <h3 class="text-weight-600 text-primary">{{ 'auth_invalid_params_error_header' | translate }}</h3>
  <p class="my-3">{{ 'auth_invalid_params_error_description' | translate }}</p>
</div>

